import { toast } from "sonner";

// Work-step twin of the controls pendingTestSkippedCopy: mirrors
// PendingTestSkipReason on the backend (pending_work_step_test.py). Keyed as a
// closed Record so a new reason is a compile error here, not a silent fallback.
export type PendingTestSkipReason = "missing_edit_workstep_test" | "failed";

export const PENDING_TEST_SKIPPED_COPY: Record<PendingTestSkipReason, string> =
  {
    missing_edit_workstep_test:
      "The Optro test wasn't created because you don't have the Set Up Work Step Test permission. Ask an administrator.",
    failed:
      "The Optro test couldn't be created. Use Add Test on this work step to try again.",
  };

const isKnownReason = (reason: string): reason is PendingTestSkipReason =>
  reason === "missing_edit_workstep_test" || reason === "failed";

export const toastPendingTestSkipped = (reason: string) => {
  toast.warning(
    PENDING_TEST_SKIPPED_COPY[isKnownReason(reason) ? reason : "failed"],
    { duration: 10000 },
  );
};
